

export const types = {
    login: '[auth] login',
    logout: '[auth] logout',

    saveTest: '[test] save'
}